<template>
  <div>
    <h2>Ajouter un ticket</h2>
    <div class="pt-10">
      <text-input
        :errors="errors.title"
        v-model="form.title"
        label="Sujet"
        type="text"
      />
    </div>

    <div class="pt-10">
      <text-area-input
        :errors="errors.content"
        v-model="form.content"
        label="Description"
      />
    </div>
    <hr />
    <div class="pt-10 d-flex-right">
      <button
        @click="saveTicket"
        :disabled="loading"
        :class="
          loading
            ? 'button is-responsive is-loading is-primary'
            : 'button is-responsive is-primary'
        "
      >
        Enregistrer
      </button>
      <button class="button is-outlined is-responsive" @click="cancelOperation">
        Annuler
      </button>
    </div>
  </div>
</template>

<script>
const Default_from = {
  title: "",
  content: "",
};
import TextInput from "@/components/TextInput";
import { TYPES } from "@/store/types";
import TextAreaInput from "@/components/TextAreaInput";
export default {
  name: "addTicket",
  components: { TextInput, TextAreaInput },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    callBackFunction: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    loading: false,
    form: {
      title: "",
      content: "",
    },
    errors: [],
  }),
  methods: {
    cancelOperation() {
      this.errors = [];
      this.form = { ...Default_from };
      this.$emit("closeModal");
    },
    saveTicket() {
      this.loading = true;
      this.$store
        .dispatch(
          `${TYPES.modules.SUPPORTS + "/" + TYPES.actions.ADD_SUPPORT}`,
          this.form
        )
        .then((res) => {
          this.loading = false;
          this.$emit("closeModal");
          this.$toast.success(`Le ticket a été envoyé`);
          this.callBackFunction();
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mcp-modal {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 400px;
  z-index: 10;
  background-color: #fff;
}

.mcp-modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #646161da;
  z-index: 5;
}
.mcp-modal-background {
  background-color: rgba(10, 10, 10, 0.86);
}
.mcp-modal-content {
  width: 400px;
}
.mcp-box {
  background-color: #fff;
  border-radius: 6px;
  color: #4a4a4a;
  display: block;
  padding: 1.25rem;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
}
input[type="checkbox"] {
  display: inline-block !important;
}
</style>